module.exports = __webpack_public_path__ + "static/media/hou.d13d6c5a.png";